import "../../css/NavBar.css";
import { SocialIcon } from "react-social-icons";
import { Link, useNavigate } from "react-router-dom";

const GOOGLE_REVIEW_URL = "https://share.google/tNvreYgh8O9exhort";

const NavBarLandscape = ({ scrollToSection }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    window.scrollTo(0, 0);
    navigate('/');
  };

  const handleContactClick = () => {
    navigate('/contact');
  };
    
  return (
    <>
    <nav>
      <div className="empty-container"></div>
      <div className="logos-container">
        <div className="facebook-container">
          <SocialIcon
            className="facebook-icon"
            url="https://www.facebook.com/brightonroofingspecialists"
            target="_blank"
            rel="noopener noreferrer"
            fgColor={"white"}
            bgColor={"#4390e8"}
            style={{ height: "5vh", width: "5vh" }}
          />
        </div>
        <img
          src="/Images/BRS-logo.png"
          alt="Brighton roofing specialists Logo"
          className="BRS-logo"
          onClick={handleLogoClick}
          style={{ cursor: 'pointer' }}
        />
        <div className="google-container">
          <a
            className="google-wrapper"
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/Images/google-logo.png"
              alt="Google Reviews logo"
              className="google-logo"
            />
          </a>
        </div>
      </div>
      <div className="get-a-quote-container" onClick={handleContactClick}>
        <h2 className="get-a-quote">GET A FREE QUOTE</h2>
      </div>
    </nav>
    <div className="page-nav">
        <h2 className="page-nav-title" onClick={() => scrollToSection("about-us")}>ABOUT US</h2>
        <h2 className="page-nav-title" onClick={() => scrollToSection("our-services")}>OUR SERVICES</h2>
        <h2 className="page-nav-title" onClick={() => scrollToSection("reviews")}>REVIEWS</h2>
        <Link to="/contact" className="page-nav-title">CONTACT US</Link>
        <Link to="/blog" className="page-nav-title">UPDATES</Link>
    </div>
    </>
  );
};

export default NavBarLandscape;
